<div class="modal-header">
  <h5 class="modal-title">Добавление файла</h5>
  <button type="button" class="close" mat-dialog-close style="outline: none">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body property-window form form-horizontal">
  <div class="form-body">
    <ng-container *ngIf="fileUploadError">
      <app-error [text]="'Ошибка загрузки: проверьте тип и размер загружаемого файла'" [selfClosed]="true"></app-error>
    </ng-container>
    <div class="form-group row">
      <label class="col-md-3 label-control"><strong>Выберите файл</strong></label>
      <div class="col-md-9">
        <input type="file" #fileUpload style="display: none" (change)="onFilesAdded()" accept="{{fileUploadType}}"/>
        <button [disabled]="uploading || uploadSuccessful" (click)="fileUpload.click()" type="button" class="btn">
          <i class="ft-file"></i>
        </button>
        <br/>
        <small class="text-primary"><i>Размер файла не должен превышать: <strong>{{fileUploadSize/1024}} Mb</strong></i></small>
        <small class="text-primary"><i>, разрешенные к загрузке файлы: <strong>{{fileUploadType}}</strong></i></small>
      </div>
    </div>
    <ng-container *ngIf="files.size > 0">
      <div *ngFor="let file of files; let i = index">
        <div class="form-group row">
          <div class="col-md-1"><strong>#{{i + 1}}</strong></div>
            <div class="col-md-11">
              <strong>файл: {{file.name}}</strong><br/>
              <mat-progress-bar *ngIf="progress" mode="determinate" [value]="progress[file.name].progress | async"></mat-progress-bar>
            </div>
        </div>
        <div class="form-group row">
          <label class="col-md-3 label-control">Заголовок</label>
          <div class="col-md-9">
            <input class="form-control" [(ngModel)]="fileElements[i].title" type="text" placeholder="Заголовок">
            <app-user-hint [text]="'Заголовок для файла (для организации вывода, необязательное поле)'"></app-user-hint>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-3 label-control">Описание</label>
          <div class="col-md-9">
            <input class="form-control" id="itemDesc" [(ngModel)]="fileElements[i].description" type="text" placeholder="Описание">
            <app-user-hint [text]="'Описание для файла (для организации вывода, необязательное поле)'"></app-user-hint>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<div class="modal-footer" style="justify-content: center">
  <button *ngIf="showCancelButton" class="btn btn-raised btn-warning mr-1" mat-dialog-close>Отмена</button>
  <button *ngIf="uploadSuccessful" class="btn btn-raised btn-warning mr-1" mat-dialog-close [mat-dialog-close]="fileElements">Закрыть</button>
  <button *ngIf="files.size > 0" class="btn btn-raised btn-info" [disabled]="!canBeClosed" (click)="closeDialog()">{{primaryButtonText}}</button>
</div>
